import React from 'react'
import * as u from '../utils'

const svgProps = (props) => {
  return {
    className: u.cls(`feather`, {}, props?.className),
    xmlns:    `http://www.w3.org/2000/svg`,
    width:    `24`,
    height:   `24`,
    viewBox:  `0 0 24 24`
  }
}

const SvgRender = (props) => {
  // eslint-disable-next-line react/prop-types
  const {children} = props

  if (!children) {
    return EmptySvg()
  }

  return (
    <svg {...svgProps(props)}>
      {children}
    </svg>
  )
}

export const EmptySvg = (props) => (
  <SvgRender {...props}>
    <path d='' />
  </SvgRender>
)

export const Email = (props) => (
  <SvgRender {...props}>
    <g transform="matrix(0.33870988,0,0,0.33870988,-0.19350139,-0.19342485)">
      <path d="m 21,30 a 2,2 0 0 0 -2,2 2,2 0 0 0 2,2 h 24 a 2,2 0 0 0 2,-2 2,2 0 0 0 -2,-2 z m 7,7 a 2,2 0 0 0 -2,2 2,2 0 0 0 2,2 h 17 a 2,2 0 0 0 2,-2 2,2 0 0 0 -2,-2 z m 0,-14 a 2,2 0 0 0 -2,2 2,2 0 0 0 2,2 h 17 a 2,2 0 0 0 2,-2 2,2 0 0 0 -2,-2 z m 22.5881,-9.9248 h 9.3782 c 1.151,0 2.0841,0.933 2.0841,2.084 v 6.5127 l 8.5251,6.3939 c 0.5172,0.3792 0.8531,0.9913 0.8531,1.6817 v 37.5126 c 0,1.151 -0.9331,2.0841 -2.0841,2.0841 H 2.65535 C 1.50433,69.3441 0.571289,68.411 0.571289,67.26 V 29.7475 c 0,-0.6904 0.335741,-1.3025 0.853051,-1.6817 l 8.52514,-6.3939 v -6.5127 c 0,-1.151 0.93302,-2.084 2.08402,-2.084 h 9.3782 L 34.7495,3.07187 c 0.7409,-0.55579 1.7598,-0.55579 2.5009,0 z M 14.1175,37.7859 25.3713,48.5037 H 47.6408 L 57.8892,38.2553 c -0.0047,-0.0566 -0.0071,-0.114 -0.0071,-0.1717 V 17.2433 H 14.1175 Z M 43.6414,13.0752 35.9999,7.34406 28.3584,13.0752 Z m 18.4088,21.0191 4.1214,-4.1214 -4.1214,-3.091 z M 9.94948,33.8163 V 26.8819 L 5.87616,29.937 Z M 47.7731,52.6719 H 24.5376 c -0.0987,0 -0.1966,-0.0071 -0.2932,-0.0208 -0.0976,0.0768 -0.193,0.1518 -0.3132,0.2463 -0.6805,0.5354 -1.4404,1.1315 -2.2611,1.7738 -2.3446,1.835 -4.7058,3.6701 -6.9333,5.3835 -0.2065,0.1589 -0.2065,0.1589 -0.4133,0.3176 -2.6995,2.0736 -4.74657,3.6374 -6.32287,4.8036 H 63.4032 Z M 4.73941,34.6102 V 62.372 C 4.805,62.3244 18.1798,52.0582 20.882,49.9841 Z M 67.2603,62.924 V 34.7788 L 51.6241,50.415 Z"/>
    </g>
    <defs>
      <clipPath>
        <rect
          width="70.857101"
          height="70.857101"
          fill="#ffffff"
          transform="translate(0.571289,0.571411)"
          id="rect3"
          x="0"
          y="0"/>
      </clipPath>
    </defs>
  </SvgRender>
)